import styled from 'styled-components'

export const FilterSelectContainer = styled.div`
    position: absolute;
    top: 30px;
    left: 16vw;
    width: 273px;
    height: 280px;
    z-index: 200;
    padding: 12px;  
    
    cursor: default;
    
    /* Cinza/Branco-100 */
    background: #FFFFFF;
    border-radius: 8px;
    filter: drop-shadow(0px 0px 8px rgba(0, 0, 0, 0.12));
    
    .list {
        position: relative;
        width: 100%;

        display: flex;
        flex-direction: column;

        overflow-y: auto;
    }

    .entry {
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;

        height: 40px;
        padding: 12px 25px;

        :hover {
            background-color: #F0F0F0;
        }
    }

    .entryName {
        font-size: 0.9rem;
        font-family: 'Roboto', sans-serif;
        font-weight: 400;
        text-align: left;
        background: none;
        border: none;
        width: 100%;
        color: black;
    }

    @media screen and (max-width:769px){
        left: 12vw;
        .header {
            margin-bottom: 0;
            margin-top: 0;
        }
    
        ::before {
            visibility: hidden;
        }
    }

`

export const SelectBack = styled.div`
    cursor: default;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 190;
`